var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { Card } from 'syf-component-library/ui/atoms/Card';
export var PaymentOptionCard = styled(Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  max-width: 400px;\n"], ["\n  max-width: 400px;\n"])));
var templateObject_1;
//# sourceMappingURL=subcomponents.js.map